export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const DURATION_TARGET_LENGTH = 2;
export const DURATION_PAD_STRING = '0';
